const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

export const formatIsoDateToAmerican = (iso: string) => {
  const datePart = iso.split('T')[0] ?? ''; // "YYYY-MM-DD"
  const [y, m, d] = datePart.split('-');

  const year = Number(y);
  const monthIndex = Number(m) - 1;
  const day = Number(d);

  if (!Number.isFinite(year) || !Number.isFinite(monthIndex) || !Number.isFinite(day)) {
    return '';
  }
  if (monthIndex < 0 || monthIndex > 11 || day < 1 || day > 31) {
    return '';
  }

  const dd = day > 9 ? String(day) : `0${day}`;
  return `${months[monthIndex]} ${dd}, ${year}`;
};
